import CluserHeadList from '../admin/CluserHeadList'

const MarektingMarClusterList = () => {
    return (
        <>
            <CluserHeadList />
        </>
    )
}

export default MarektingMarClusterList